// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chip_wrapper__u7VBy","icon":"Chip_icon__keyex","text":"Chip_text__04D0D"};